import Header from '@/components/header/index.vue';
import Search from '@/components/search/index.vue';
import Menu from '@/components/menu/index.vue';
import Bottom from '@/components/bottom/index.vue';
import UploadImage from '../upload-image/index.vue';
import ProcessNavigation from '@/components/process-navigation/index.vue';
import { errorMessage } from '@/utils/message.js';
import { mapGetters } from 'vuex';
import PublishProjectService from '../../publish-project-service.js';

export default {
  components: {
    Header,
    Search,
    Menu,
    Bottom,
    UploadImage,
    ProcessNavigation
  },
  props: {
    getdataid: {
      type: Number,
      default: {}
    },
    showfile: {
      type: String,
      default: {}
    }
  },

  data () {
    return {
      step: 4,
      id: '',
      oldId: '',
      isCreated: true,
      projectInfo: {},
      form: {
        files: []
      },
      fileTEXTfbitem: [],
      fileTEXTmzitem: [],
      fileTEXT: '',
      projectType: 1, // 项目类型
      projectSubType: 1, // 项目子类
      submitStatus: ''
    };
  },
  computed: {
    ...mapGetters([
      'userInfo',
      'processList',
      'tradeType'
    ])
  },
  created () {
    if (Number(this.tradeType) === 3) {
      this.$store.commit('SET_PROCESS_LIST', ['编辑项目信息', '上传附件信息', '承诺信息', '提交申请']);
      this.step = 2;
    }
    this.projectType = this.$route.query.projectType; // 项目类型
    this.projectSubType = this.$route.query.projectSubType; // 项目子类
    if (this.tradeType === '2') {
      this.step = 2;
    }
    this.initFiles();
    this.id = this.$route.query.id;
    this.oldId = this.$route.query.oldId;
    if (this.id) {
      PublishProjectService.getFile(this.id).then(res => {
        this.isFileInfo = res.data;
        this.getProjectInfo();
      });
      this.fileTEXT = '文件没有改动';
    } else {
      this.fileTEXT = '发布项目';
    }
    if (this.showfile === 'file') {
      if (this.id) {
        PublishProjectService.getFile(this.id).then(res => {
          this.isFileInfo = res.data;
        });
      } else {
        PublishProjectService.getFile(this.getdataid).then(res => {
          this.isFileInfo = res.data;
          this.fileTEXT = '文件没有改动';
          // console.log(this.fileTEXT);
          this.getProjectInfo();
        });
      }
    }
  },
  methods: {
    initFiles () {
      this.form.files = [
        { projectFileType: 2, title: '民主决策决议', filePaths: [], defaultImage: [], inputValue: null },
        { projectFileType: 3, title: '发包方案', filePaths: [], defaultImage: [], inputValue: null },
        { projectFileType: 9, title: '其他材料', filePaths: [], defaultImage: [], inputValue: null }
      ];
    },
    getProjectInfo () {
      this.isFileInfo.democraticDecisionMakingUrl.forEach(res => {
        this.form.files[0].defaultImage.push({ url: res });
      });
      this.isFileInfo.letContractUrl.forEach(res => {
        this.form.files[1].defaultImage.push({ url: res });
      });
      if (this.isFileInfo.othersUrl) {
        this.isFileInfo.othersUrl.forEach(res => {
          this.form.files[2].defaultImage.push({ url: res });
        });
      }
      // console.log(this.form.files[0].defaultImage);
    },
    uploadImage (index, event) {
      this.form.files[index].filePaths = event;
      if (event.length) {
        this.form.files[index].inputValue = event.length;
      } else {
        this.form.files[index].inputValue = null;
      }
    },
    getfileList (index, item) {
      // console.log(item, 111);
      if (index === 0) {
        this.fileTEXT = '文件改动';
        this.fileTEXTmz = '文件改动1';
        this.fileTEXTmzitem = item;
        // console.log(item, this.fileTEXT, this.fileTEXTmz);
        let filemz = new FormData();
        item.forEach(item => {
          filemz.append('files', item.raw);
        });
        filemz.append('id', this.getdataid);
        this.filemz = filemz;
      }
      if (index === 1) {
        this.fileTEXT = '文件改动';
        this.fileTEXTfb = '文件改动2';
        // console.log(item, this.fileTEXT, this.fileTEXTfb);
        this.fileTEXTfbitem = item;
        let filefb = new FormData();
        item.forEach(item => {
          filefb.append('files', item.raw);
        });
        filefb.append('id', this.getdataid);
        this.filefb = filefb;
      }
      if (index === 2) {
        // console.log(1);
        this.fileTEXTqt = '文件改动3';
        this.fileTEXT = '文件改动';
        this.fileTEXTqtitem = item;
        let fileqt = new FormData();
        item.forEach(item => {
          fileqt.append('files', item.raw);
        });
        fileqt.append('id', this.getdataid);
        this.fileqt = fileqt;
      }

    },
    previousStep () {
      // console.log(this.getdataid);
      this.$emit('showstep', 'back');
      this.$emit('getdataid', this.getdataid);
    },
    uploadfilejk () {
      // console.log(this.getfilelist);
      this.submitStatus = 'ongoing';
      if (this.id || this.showfile === 'file') {
        if (this.showfile === 'file') {
          if (this.getdataid === 0) {
            this.id = this.$route.query.id;
          } else {
            this.id = this.getdataid;
          }
        }
        // console.log(this.id);
        if (this.getfilelist[3] === 'nochange') {
          let params = new FormData();
          params.append('id', this.id);
          params.append('democraticDecisionMakingUrl', this.getfilelist[0]);
          params.append('letContractUrl', this.getfilelist[1]);
          params.append('othersUrl', this.getfilelist[2]);
          PublishProjectService.editFile(params).then(res => {
            if (res.code === '0') {
              this.$emit('showstep', 'next');
            } else {
              errorMessage(res && res.reason);
            }
          });
        }
      } else {
        PublishProjectService.uploadDemocraticDecisionMaking(this.getfilelist[0]).then(res => {
          if (res.code === '0') {
            PublishProjectService.uploadLetContract(this.getfilelist[1]).then(res => {
              if (res.code === '0') {
                if (this.getfilelist[2] !== undefined) {
                  PublishProjectService.uploadOther(this.getfilelist[2]).then(res => {
                    if (res.code === '0') {
                      this.$emit('showstep', 'next');
                    } else {
                      errorMessage(res && res.reason);
                    }
                  }, () => {
                    this.$message.error('发布项目失败');
                  });
                } else {
                  this.$emit('showstep', 'next');
                }
              } else {
                errorMessage(res && res.reason);
              }
            });
          } else {
            errorMessage(res && res.reason);
          }
        });

      }
    },
    next () {
      // console.log(this.getdataid);
      this.$refs['attachmentForm'].validate(valid => {
        if (valid) {
          // console.log(this.fileTEXT);
          if (this.id || this.showfile === 'file') {
            if (this.fileTEXT === '文件没有改动') {
              // console.log(this.isFileInfo.othersUrl);
              if (this.isFileInfo.othersUrl === null) {
                this.isFileInfo.othersUrl = '';
              }
              this.getfilelist = [this.isFileInfo.democraticDecisionMakingUrl, this.isFileInfo.letContractUrl, this.isFileInfo.othersUrl, 'nochange'];
              this.uploadfilejk();
            }
            if (this.fileTEXT === '文件改动') {
              // console.log(this.fileTEXTmzitem, this.fileTEXTfbitem);
              if (this.fileTEXTmz === '文件改动1' && this.fileTEXTmzitem.length === 0) {
                this.$message.error('请上传附件');
                return;
              }
              if (this.fileTEXTfb === '文件改动2' && this.fileTEXTfbitem.length === 0) {
                this.$message.error('请上传附件');
                return;
              }
              this.fburl = [];
              this.mzurl = [];
              this.qturl = [];
              var filemz = new FormData();
              if (this.fileTEXTmzitem.length !== 0) {
                this.fileTEXTmzitem.forEach(res => {
                  if (res.raw) {
                    filemz.append('democraticDecisionMakingFile', res.raw);
                  } else {
                    this.mzurl.push(res.url);
                  }
                });
              } else {
                this.mzurl = this.isFileInfo.democraticDecisionMakingUrl;
              }
              filemz.append('democraticDecisionMakingUrl', this.mzurl);
              if (this.fileTEXTfbitem.length !== 0) {
                this.fileTEXTfbitem.forEach(res => {
                  if (res.raw) {
                    filemz.append('letContractFile', res.raw);
                  } else {
                    this.fburl.push(res.url);
                  }
                });
              } else {
                this.fburl = this.isFileInfo.letContractUrl;
              }
              filemz.append('letContractUrl', this.fburl);
              if (this.fileTEXTqtitem) {
                this.fileTEXTqtitem.forEach(res => {
                  if (res.raw) {
                    filemz.append('othersFile', res.raw);
                  } else {
                    this.qturl.push(res.url);
                  }
                });
              } else {
                if (this.isFileInfo.othersUrl === null) {
                  this.isFileInfo.othersUrl = '';
                } else {
                  this.qturl = this.isFileInfo.othersUrl;
                }
              }
              filemz.append('othersUrl', this.qturl);
              if (this.id) {
                filemz.append('id', this.id);
              } else {
                filemz.append('id', this.getdataid);
              }
              PublishProjectService.editFile(filemz).then(res => {
                if (res.code === '0') {
                  this.$emit('showstep', 'next');
                } else {
                  errorMessage(res && res.reason);
                }
              });
            }
          } else {
            if (this.fileTEXTfbitem.length === 0 || this.fileTEXTmzitem.length === 0) {
              this.$message.error('请上传附件信息');
            } else {
              this.getfilelist = [this.filemz, this.filefb, this.fileqt];
              this.uploadfilejk();
              return;
            }

          }
        } else {
          return false;
        }
      });
    }
  }
};
